export enum userRoles {
  superAdmin = 1,
  companyOwner = 2,
  companyUser = 3,
  legalese = 4,
  companyAdmin = 5
}